module.exports = __webpack_public_path__ + "img/Extrait_naega.287ac778.jpg";